import type { FecImportItem } from '../query-api'

export const getFecImportSessionFileSize = (fecImport: FecImportItem, sessionFiles: File[]): number | undefined =>
  sessionFiles.find((file) => file.name === fecImport.fileName)?.size
